import { requestGet } from '@/common/request';
import env from '@/env';

// 获取模板配置
export function getTemplateConfig(param) {
  return requestGet(`${env.MAC_DOMAIN}/layout/template/schema/${param}`);
}
